<div class="card m-1">
  <div class="card-body">
    <div class="row">
      <div class="col-6 text-center">
        <h4>{{ business?.business?.nomCommercial }}</h4>
        <p>{{ business?.business?.tel }}</p>
        <a *ngIf="business?.business?.contactEmail && business?.business?.contactEmail != ''" href="mailto:{{business?.business?.contactEmail}}">{{ business?.business?.contactEmail }}</a>
      </div>
      <div class="col-6 text-center">
        <div class="d-flex flex-column flex-nowrap">
          <h3 class="text-info">{{business?.pickUps?.length}}</h3>
          <p>PickUps</p>
        </div>
        <app-jobs-badge-status
          [status]="business?.pickUps[0]?.status"
          [item]="business?.pickUps[0]"
        >
        </app-jobs-badge-status>
      </div>
    </div>
    <div style="background-color: #aba8a8; height: 1px; width: 100%" class="mt-3"></div>
    <div class="mt-2 d-flex">
      <div class="">
        <button class="btn btn-outline-info p-1 px-2" >Détail</button>
      </div>
      <div class="ml-auto">
        <button class="btn btn-primary p-1 px-2" (click)="onPickUPListClick.emit()">PickUps</button>
      </div>
    </div>
  </div>
</div>
